<template>
  <div class="container">
    <form method="post" id="payment-form" @submit.prevent="submitPayment">    
      <!-- <div class="form-row top-row">
        <div id="amount" class="field card-number">
          <input name="amount" placeholder="Amount">
        </div>
      </div> -->

      <div class="form-row top-row">
        <div id="card-number" class="field card-number"></div>
        <div class="input-errors" id="card-number-errors" role="alert"></div>
      </div>

      <div class="form-row">
        <div id="card-date" class="field third-width"></div>
        <div class="input-errors" id="card-date-errors" role="alert"></div>
      </div>
     
      <div class="form-row">
        <div id="card-cvv" class="field third-width"></div>
        <div class="input-errors" id="card-cvv-errors" role="alert"></div>
      </div>
       
      <div class="form-row">
        <div id="card-postal-code" class="field third-width"></div>
        <div class="input-errors" id="card-postal-code-errors" role="alert"></div>
      </div>
       
      <div id="card-response" role="alert"></div>

      <div class="button-container">
        <button>Register Card</button>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'CloverPaymentForm',
  mounted() {
    const script = document.createElement('script');
    script.src = process.env.VUE_APP_CLOVER_CHECKOUT_ENDPOINT;
    document.head.appendChild(script);

    script.onload = () => {
        //Clover elements setup
        const clover = new window.Clover(process.env.VUE_APP_CLOVER_API_KEY);
        const elements = clover.elements();
        console.log('Elements:', elements);

        const styles = {
            body: {
            fontFamily: 'Roboto, Open Sans, sans-serif',
            fontSize: '16px',
            },
            input: {
            fontSize: '20px'
            }
        };

            // Mounting Clover elements
            const cardNumber = elements.create('CARD_NUMBER', styles);
            const cardDate = elements.create('CARD_DATE', styles);
            const cardCvv = elements.create('CARD_CVV', styles);
            const cardPostalCode = elements.create('CARD_POSTAL_CODE', styles);

            cardNumber.mount('#card-number');
            cardDate.mount('#card-date');
            cardCvv.mount('#card-cvv');
            cardPostalCode.mount('#card-postal-code');
            this.clover = clover;
        }
    },
    methods:{
        submitPayment() {
        // Ensure `this.clover` is available from mounted
            this.clover.createToken()
            .then((result) => {
            if (result.errors) {
                Object.values(result.errors).forEach((value) => {
                console.error(value);
                });
            } else {
                console.log('Token created:', result.token);
                // Emit the event with the token
                this.$emit('cloverTokenizedCard', result.token);
            }
            })
            .catch((error) => {
            console.error('Error during token creation:', error);
            });
        }
    }
}
</script>

<style scoped>
.container {
  background-color: #FFFFFF;
  border-radius: 25px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 24px;
  margin-top: 10px;
  width: 300px;
}

.clover-footer{
  background-color: #fff !important;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 25px !important;
}

.container .form-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.container .form-row.top-row {
  margin-top: 16px;
}

input {
  border: none;
  box-sizing: border-box;
  height: 1.2em;
  outline: 0;
  width: 100%;
  padding: 0;
  margin: 0;
  font-size: 20px;
}

.input-errors {
  font-size: 12px;
  position: absolute;
  margin-left: 5px;
  margin-top: 54px;
  color: red;
}

.container .form-row .field {
  box-sizing: border-box;
  border: 1px solid #DEE0E1;
  border-radius: 3px;
  height: 55px;
  margin-bottom: 30px;
  padding: 14px;
  width: 100%;
}

.container .button-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.container .button-container button {
  background-color: #33f18a;
  border: none;
  border-radius: 15px;
  color: #FFFFFF;
  display: block;
  height: 47px;
  width: 300px;
  cursor: pointer;
  transition-duration: .25s;
}

.container .button-container button:hover {
  background-color: #2fde7e;
  cursor: pointer;
  transition-duration: .25s;
}

#payment-request-button {
  width: 85%;
  height: 40px;
  margin: 0 auto;
}

@media (min-width: 300px) {
  body {
    width: auto;
  }
}

.hr {
  width: 100%;
  height: 10px;
  border-bottom: 1px solid black;
  text-align: center;
  margin: 20px 0;
}

.hr span {
  font-size: 10px;
  background-color: #FFF;
  padding: 0 10px;
}

.clover-privacy-link {
  font-family: Roboto, "Open Sans", sans-serif;
}
</style>